import Home from '../pages/Home.vue'
import MagicLogin from "@/pages/MagicLogin";

const routes = () => [
  {
    name: 'Home',
    path: '/',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'magic-login',
    path: '/magic-login',
    component:MagicLogin,
    meta: {
      requiresAuth: false
    }
  },
]

export default routes